import { UPDATE_ITINERARY_OVERVIEW_DATA, RESET_ITINERARY_OVERVIEW_DATA } from "./displayItineraryOverviewReducer"

export const updateItineraryOverviewData = (obj) => ({
    type: UPDATE_ITINERARY_OVERVIEW_DATA,
    payload: obj
})

export const resetItineraryOverviewData = () => ({
    type: RESET_ITINERARY_OVERVIEW_DATA,
})